module.exports = __webpack_public_path__ + "static/the-happiest-baby-on-the-block-b506e3879a6b0986db7e93899e70e0a8.jpg";